<template>
  <div class="customer-notice">
    <span class="tip ml-12" v-show="!checkHasEmail">
      <i class="el-icon-warning-outline"></i>
      {{ $t('customer::customers-notice::setting_right') }}
    </span>
    <el-button type="primary" class="setting-button" @click="$router.push({ name: 'shop-site' })">
      {{ $t('customer::customers-notice::email_setting') }}
    </el-button>
    <el-card>
      <el-tabs v-model="activeTab">
        <el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in tabs" :key="index"></el-tab-pane>
      </el-tabs>

      <div style="margin: 10px 0 20px;">
        <div class="marketing">
          <span>{{ $t('customer::customers-notice::setting_tips') }}</span>
          <el-button type="primary" @click="toAdd" v-auth="'customer::customers-notice::active-add'">
            {{ $t('customer::customers-notice::add') }}
          </el-button>
        </div>
      </div>

      <z-table v-loading="loading" :data="list" :columns="columns" :max-height="500" :pagination="false">
        <template #filter="{ row }">
          <el-tooltip placement="top-start">
            <div slot="content">{{ checkReceiver(row) }}</div>
            <div style="display:flex;">
              <div class="recevier">{{ checkReceiver(row) }}</div>
              <span style="color:#7f7fa8;">(共{{ row.toCount }}人)</span>
            </div>
          </el-tooltip>
        </template>
        <template #sentDate="{ row }">
          {{
            (row.status === 0 || row.status === 1) && row.delayToSendDate
              ? `${$t('customer::customers-notice::预计')}${row.delayToSendDate}`
              : row.sentDate
          }}
        </template>
        <template #status="{ row }">
          <el-tag :type="statusList[row.status].type">
            {{ statusList[row.status].label }}
          </el-tag>
        </template>
        <template #operate="{ row }">
          <el-button
            type="text"
            @click.stop="toDetail(row)"
            v-if="row.status === 2 || row.status === 3"
            v-auth="'customer::customers-notice::active-detail'"
          >
            {{ $t('customer::customers-notice::check') }}
          </el-button>
          <el-button
            type="text"
            @click.stop="edit(row)"
            v-if="row.status === 0 || row.status === 1"
            v-auth="'customer::customers-notice::active-edit'"
          >
            {{ $t('customer::customers-notice::edit') }}
          </el-button>
          <el-button
            type="text"
            @click.stop="send(row)"
            v-if="row.status === 0"
            v-auth="'customer::customers-notice::active-send'"
          >
            {{ $t('customer::customers-notice::send') }}
          </el-button>
          <el-button type="text" @click.stop="remove(row)" v-auth="'customer::customers-notice::active-delete'">
            {{ $t('customer::customers-notice::delete') }}
          </el-button>
        </template>
      </z-table>
    </el-card>
    <sendDialog v-model="isShowSend" :emailModel="selectModel" @save="close"></sendDialog>
  </div>
</template>

<script>
import sendDialog from './components/sendDialog'
import { MARKETING_COLUMNS, SEND_STATUS, STEP_STAUTS } from '../config'
import { getEmailInfoList } from '@/server/after-sales.js'
import { getEmailList, updateEmailModule, getEmailDetail } from '@/server/customers.js'
export default {
  components: { sendDialog },
  data() {
    return {
      tabs: [{ label: this.$t('customer::customers-notice::sell_strategy'), name: 'marketing-planning' }],
      activeTab: 'marketing-planning',
      loading: false,
      columns: MARKETING_COLUMNS,
      statusList: SEND_STATUS,
      stepStauts: STEP_STAUTS,
      list: [],
      checkHasEmail: true,
      pagination: {
        pageNum: 1, // 页码
        pageSize: 20, // 每页大小
        total: 0
      },
      isShowSend: false,
      selectModel: {}
    }
  },
  mounted() {
    this.getEmailInfoList()
    this.getEmailList()
  },
  methods: {
    // 显示判断收件人
    checkReceiver(row) {
      if (row.filter === 0) {
        return this.$t('system::common::select_all')
      } else if (row.filter === 3) {
        return this.$t('customer::customers-notice::count') + this.stepStauts[row.filterValue]
      } else {
        return row.filterName
      }
    },
    // 获取所有商家邮箱
    async getEmailInfoList() {
      let { data } = await getEmailInfoList({ pageNum: 1, pageSize: 10 })
      if (data.code === this.$code) {
        this.checkHasEmail = !!data.data.items.length
      }
    },
    // 获取营销活动列表
    async getEmailList() {
      this.loading = true
      let { data } = await getEmailList({})
      if (data.code === this.$code) {
        this.list = data.data || []
      }
      this.loading = false
    },
    toAdd() {
      if (!this.checkHasEmail) {
        this.$message.warning(this.$t('customer::customers-notice::warning_message'))
      } else {
        this.$router.push({ path: '/notice/add' })
      }
    },
    toDetail(row) {
      this.$router.push(`/notice/detail/${row.id}`)
    },
    edit(row) {
      this.$router.push({ path: `/notice/edit/${row.id}` })
    },
    send(row) {
      this.isShowSend = true
      this.selectModel = { ...row }
    },
    remove(row) {
      this.$confirm(
        `<p>${this.$t('customer::customers-notice::delete_confirm')}</p><p>${this.$t(
          'customer::customers-notice::delete_tips'
        )}</p>`,
        $t('customer::customers-notice::tips'),
        {
          confirmButtonText: this.$t('customer::customers-notice::confirm'),
          cancelButtonText: this.$t('customer::customers-notice::cancel'),
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        this.removeModel(row)
      })
    },
    // 删除邮件
    async removeModel(row) {
      const { data } = await updateEmailModule({ ...row, isDeleted: 1 })
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::delete_success'))
        this.getEmailList()
      }
    },
    // 点击发送后开始发送，遍历状态，判断是否完成
    async getEmailDetail(id) {
      const self = this
      const { data } = await getEmailDetail({ id: id })
      if (data.code === this.$code) {
        if (data.data.status === 3) {
          self.$message.success(this.$t('system::tip::send_success'))
          self.getEmailList()
        } else if (data.data.status === 2) {
          setTimeout(() => {
            self.getEmailDetail(id)
          }, 2000)
        }
      }
    },
    // 如果有ID则是发送，没有则是存草稿
    close(id) {
      this.isShowSend = false
      if (id) {
        this.getEmailDetail(id)
      }
      this.selectModel = {}
      this.getEmailList()
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 20px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.tip {
  margin-left: 10px;
  font-size: 14px;
  font-weight: 400;
  color: red;
  position: absolute;
  left: 105px;
  top: 28px;
}
.setting-button {
  position: absolute;
  right: 40px;
  top: 18px;
}
.marketing {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.recevier {
  display: inline-block;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
